import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  withCredentials: true, // Necessary for Laravel Sanctum
});

// Fetch CSRF token before making a request
axiosInstance.interceptors.request.use(async (config) => {
    const response = await axios.get(process.env.REACT_APP_API_BASE + '/sanctum/csrf-cookie', {
    withCredentials: true
});
 
  // Manually attach CSRF token from cookies
  const xsrfToken = getCookie('XSRF-TOKEN');
  if (xsrfToken) {
    config.headers['X-XSRF-TOKEN'] = xsrfToken;
  }else{
   
  }
  return config;
});

// Function to read cookies
function getCookie(name) {
  const cookies = document.cookie.split('; ');
  for (let cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split('=');
    if (cookieName === name) return decodeURIComponent(cookieValue);
  }
  return null;
}

export default axiosInstance;
